import _jsx from "@babel/runtime/helpers/jsx";

var _CheckIcon;

import React, { memo } from 'react';
import Hint from 'components/Hint';
import { ProductActionsWrapper, ProductActionsList, ProductAction, FinawardsIcon, CheckIcon } from './styles';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MAP_CODE_TO_ICON = {
  fa: 'original',
  ga: 'gold',
  sa: 'silver',
  ba: 'bronze'
};

var handleIconCode = function handleIconCode(title) {
  var iconCodeRegExp = / (fa|ga|sa|ba)$/;

  if (iconCodeRegExp.test(title)) {
    var code = title.match(iconCodeRegExp)[1];
    var titleWithoutCode = title.replace(iconCodeRegExp, '');
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [titleWithoutCode, /*#__PURE__*/_jsx(FinawardsIcon, {
        name: MAP_CODE_TO_ICON[code]
      })]
    });
  }

  return title;
};

function ProductActions(_ref) {
  var advantages = _ref.advantages;
  return /*#__PURE__*/_jsx(ProductActionsWrapper, {}, void 0, /*#__PURE__*/_jsx(ProductActionsList, {}, void 0, advantages.map(function (advantage) {
    return /*#__PURE__*/_jsx(ProductAction, {}, advantage.title, _CheckIcon || (_CheckIcon = /*#__PURE__*/_jsx(CheckIcon, {})), handleIconCode(advantage.title), /*#__PURE__*/_jsx(Hint, {
      position: "bottom"
    }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, advantage.description)));
  })));
}

export default /*#__PURE__*/memo(ProductActions);